<template>
    <div class="cooperationOrder">
        <headers :title="'在线预约'"/>
        <!-- 地址栏 -->
          <div class="addressOut"  @click="changeAddress">
                 <div class="addressContent" v-if="!!Address">
                     <div class="namePhone">
                         <div class="name">{{Address.guestName}}</div>
                         <div class="phone">{{Address.guestPhone}}</div>
                         <div class="acreage" v-if="Address.Acreage">{{Address.Acreage}}㎡</div>
                     </div>
                     <div class="address">
                       {{Address.guestAddress}}
                     </div>
                 </div>
                 <div class="addressContent" v-else>
                 </div>
                 <div class="addressRight">
                     <span class="iconfont iconyoujiantou"></span>
                 </div>
          </div>
          <!-- 订单信息 -->
           <div class="serviceItems">
               <p class="serviceTitle">服务项目</p>
               <div class="serviceText">
                   <p>{{ContentTitle}}</p>
               </div>
           </div>
           <!--备注 -->
           <van-cell-group class="message">
                    <van-field
                        v-model="message"
                        label="备注"
                        type="textarea"
                        placeholder="请输入留言"
                        rows="1"
                        autosize
                    />
            </van-cell-group>
            <!-- 脚步导航 -->
        <div class="foot">
          <div class="kf"><a href="tel:4001500600">客服</a></div>
          <div class="confirm"  @click="confirmOrder">确认下单</div>
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex'
import { Toast } from 'vant'
export default {
    data () {
        return {
            message: '',
            Address:{},
            ContentTitle: '',
            ContentId: null,
            ServiceId: null,
            ContentType: '',
            isConfirmOrder: false,
            CanOrder:0, // 1-可预订
            CanNotOrderTips: "",//不可预订时提示
        }
    },
    computed:{
       ...mapState(['orderAddress'])
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'AddressList') { //判断是从哪个路由过来的
          to.meta.isBack = true;
      }
      next();
    },
    created () {
         this.getData()
    },
     mounted(){
      if (this.$route.meta.isBack){ // 选地址后 后退的数据
          if (this.orderAddress.length > 0) {
            this.Address = this.orderAddress[0]
          } 
          let cooperationObj = JSON.parse(localStorage.getItem('cooperationObj'))
          this.message = cooperationObj.message
          localStorage.removeItem('cooperationObj')
      }
    },
    /* activated(){
          if (this.orderAddress.length > 0) {
             this.Address = this.orderAddress[0]
          }  

          if(!this.$route.meta.isBack) {  // 不是后退，重新拿数据
             
             this.message = ''
             this.getData()
             
            }
            this.$route.meta.isBack = false
    }, */
    methods: {
      getData () {
        // 发送请求
       let key = this.$route.query.by  === 'sid' ? 'ServiceId' : 'ContentId'
       let id = this.$route.query.id
       this.$axios.get('/api/DjOrder/GetContentInfo',{
          params: {

            [key]: id
          }
       }).then(res => {
          let data = res.data
          //  console.log(data)
          this.CanOrder = data.CanOrder
          this.CanNotOrderTips = data.CanNotOrderTips
         
          this.ContentTitle = data.ContentTitle
         
          this.ContentId = data.ContentId
          this.ServiceId = data.ServiceId
          this.ContentType = data.ContentType 
       })

       if (this.orderAddress.length <= 0) {
            // 获取地址请求
            this.$axios.get('/api/DjAddress/GetAddressList').then(res => {
            let data = res.data
            if(data.length>0){
              this.Address = data[0]
            }
          })
       }

       


      },
      changeAddress () {
        let _this = this
          let cooperationObj = {
             message:_this.message
             
          }
          localStorage.setItem('cooperationObj', JSON.stringify(cooperationObj))
          this.$router.push('/addresslist')
        },
      confirmOrder () {
        if(this.CanOrder == 0){
          Toast(this.CanNotOrderTips);
          return
        }

        if (!this.Address) {
            Toast('请输入有效地址信息！');
            return
            }
            

         if(!this.isConfirmOrder){
              this.isConfirmOrder = true
              // 提交订单
            this.$axios.post('/api/DjOrder/SaveOrder',{
              CustomerName: this.Address.guestName,
              CustomerPhone: this.Address.guestPhone,
              CustomerAddress: this.Address.guestAddress,
              Add0: this.Address.address0,
              Add1: this.Address.address1,
              Add2: this.Address.address2,
              Acreage: this.Address.Acreage,
              CustomerRemarks: this.message,
              OrderFlag: this.ContentType,
              ContentId: this.ContentId,
              ServiceId: this.ServiceId,
            }).then(res => {
              // console.log(res)
              if (res.data.type == 1 ) {
                Toast.success({
                  message: '成功预订',
                  duration: 500
                })
                this.isConfirmOrder = false
                this.$router.push('/orderlist')
              }else{
                this.isConfirmOrder = false
                Toast(res.data.message);
              }
              
            }).catch(() => {
              this.isConfirmOrder = false
              Toast('提交失败，请重新提交！');
            })
         }
        
      }
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.cooperationOrder
  background: rgb(240, 240, 240)
  height: 100%
  .addressOut
    width: 100%
    height: 80px
    margin-top: 45px
    background: #f7f4e4
    position: relative
    display: flex
    justify-content: center
    align-items: center
    font-size: 14px
    color: #6b6b6b
    &::before
     content:''
     position:absolute
     top:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")   
    &::after
     content:''
     position:absolute
     bottom:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")
    .addressContent
      height: 100%
      width: 90%
      margin-left: -2px
      display: flex
      flex-direction: column
      justify-content: center
      padding: 5px
      .namePhone
        display: flex
        margin-bottom: 12px
        .name
          margin-right: 12px
        .phone
          margin-right: 64px
    .addressRight
      &>span
        font-size: 28px
  .serviceItems
    width: 100%
    background: white
    margin-top: 6px
    padding-left: 8px
    padding-top: 8px
    box-sizing: border-box
    height: 80px
    .serviceTitle
      margin-bottom: 6px
      font-size: 14px
    .serviceText
      width: 96%
      border: 1px solid #bfbfbf
      border-radius: 6px
      padding: 8px
      box-sizing: border-box
      background: rgb(240, 240, 240)
      font-size: 13px
      line-height: 18px
      color: #333
      &>p:last-child
        margin-top: 4px
  .foot
    width: 100%
    height: 40px
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    .confirm
      width: 70%
      height: 100%
      background: #c21a1a
      text-align: center
      line-height: 40px
      color: white
    .kf
      width: 30%
      height: 100%
      background: #009933
      text-align: center
      line-height: 40px
      color: white
      & a
        color white
        display: inline-block
        width 100%
        height 100%
        display flex
        align-items center
        justify-content center
  >>> .van-ellipsis
   overflow: visible
</style>



// WEBPACK FOOTER //
// src/pages/Order/CooperationOrder.vue